import { Contact } from '../../../models';
export function contactRelationshipsDtoToContact(relationshipsDto) {
  var isIndividual = /^[A-Z][A-Z]INDIVIDUAL$|^INDIVIDUAL$/.test(relationshipsDto.contactEntityType.id);
  return new Contact(relationshipsDto.contact.id, relationshipsDto.contact.displayAs, relationshipsDto.contactIsClientCenterEnabled, isIndividual, undefined, undefined, relationshipsDto.contact.primaryEmail.emailAddress, relationshipsDto.relationshipSide.name);
}
